import { create } from 'zustand'
import type { ConversationTurnDTO } from '@/api/generated/models'

export type LiveTurn = ConversationTurnDTO & { room_name?: string }

interface TestCallTranscriptState {
  activeRoom: string | null
  turns: LiveTurn[]
  startSession: (roomName: string) => void
  endSession: () => void
  upsertTurn: (turn: LiveTurn) => void
}

export const useTestCallTranscriptStore = create<TestCallTranscriptState>((set, get) => ({
  activeRoom: null,
  turns: [],
  startSession: (roomName) => set({ activeRoom: roomName, turns: [] }),
  endSession: () => set({ activeRoom: null, turns: [] }),
  upsertTurn: (turn) => {
    const { activeRoom, turns } = get()
    if (!activeRoom || turn.room_name !== activeRoom) return
    const idx = turns.findIndex(
      (t) =>
        (turn.id && t.id === turn.id) ||
        (turn.turn_number !== undefined && t.turn_number === turn.turn_number),
    )
    if (idx === -1) {
      set({ turns: [...turns, turn] })
      return
    }
    const next = turns.slice()
    next[idx] = { ...next[idx], ...turn }
    set({ turns: next })
  },
}))
